import React from 'react';
import {
  OmniTableComponent,
  OmniStyleComponent,
  OmniTileComponent,
  OmniToolbarComponent,
  OmniSearchComponent,
} from '../../../shared/components/omni-components';
import handIcon from '../../../images/icon-subcription.svg';
import '../../../styles/rfpDetails.css';
import { RfpDialogComponent } from './rfpDialogComponent';
import { exportStatusHtml, MediaOpsService, Utils, AlertMessagesService } from "../../../shared";
import { html } from 'lit';
import parse from 'html-react-parser';
import { RfpService } from '../';
import RfpPreview from './RfpPreview';
import { RfpFilterComponent } from './rfpFilterComponent';
import { PlacementDetailsTableService } from '../../placements';

export class RfpDetailsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterParams: {},
      scrollFlag: true,
      sort: {
        key: 'name',
        dir: 'asc'
      },
      isRfpModalOpen: false,
      loading: true,
      rfpData: [],
      activeTab: true,
      rfpPreview: false,
      editRFPData : null,
      filtersApplied: false
    };
    this.totalCount = 0;
    this.fetchCount = 0;
    this.tablePageNo = 1;
    this.apiCallCount = 1;
    this.selectedRfp = {};
  }

  /** The above code is defining a function called `openRfpPreviewModal` that takes in a parameter
  * `rfp`. Within the function, it sets the state of `rfpPreview` to `true` and `selectedRfp` to the
  * value of the `rfp` parameter. This function is likely used to open a modal that displays a preview
  * of the selected RFP (Request for Proposal). 
  * @param {JSON} rfp - Rfp Object to be set as selected rfp
  * @returns {void}
  */
  openRfpPreviewModal = (rfp) => {
    this.setState({
      rfpPreview: true
    });
    this.selectedRfp = rfp;
    this.closeMenu(-1, '');
  };


  /**
  * Archives or activates an RFP.
  * @param {Object} rfp - The RFP object to be archived or activated.
  */
  archiveOrActivateRfp = (rfp) => {
    let campaignId = encodeURIComponent(this.props.state.campaignObj.id);
    this.props.setSpinnerCount(1);
    RfpService.updateRfp(rfp.id, { isDelete: this.state.activeTab, updatedBy: this.props?.omniProfile?.email}, campaignId)
      .then(() => {
        AlertMessagesService.showSuccessToastMessage(`${this.state.activeTab? 'Archived':'Activated'} RFP successfully`)
        this.removeRfpFromStateList(rfp)
      }).catch(() => {
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.archiveOrActivateRfp(rfp), title: `Unable to ${this.state.activeTab ? 'archive' : 'activate'} the RFP`, bodyMsgArr: []}]);
      })
      .finally(() => {
        this.props.setSpinnerCount(0);
    })
    
  }

  /**
   * Sends the RFP (Request for Proposal) to Media Ocean.
   * @param {Object} rfp - The RFP object to send.
   * @returns {Promise<void>} - A promise that resolves when the RFP is successfully sent to Media Ocean.
   */
  sendToMediaOcean = (rfp) => {
    this.props.setSpinnerCount(1);
    RfpService.sendToMediaOcean(rfp, this.props.state.campaignObj)
      .then((response) => {
        let respMsgArr = [];
            respMsgArr.push({type:"success",title:`${response.status} - RFP is sent to Media Ocean`,"bodyMsgArr":[html`RFP Name:<br/>${rfp.rfp_name}`]})
            AlertMessagesService.showMultipleAlerts(respMsgArr);
        this.getRfpList()
      }).catch((err) => {
        let respMsgArr = [];
        const response = err.response
        const result = err.response?.data
        if (result?.validationResults) {
          respMsgArr.push({type:"danger", retryBtnText: 'Retry', retryBtnEvent: () => this.sendToMediaOcean(rfp), title:`${response?.status} - Unable to sent to media ocean`,"bodyMsgArr":result.validationResults.map(item => html`RFP name: ${rfp.rfp_name}<br>Field name: ${item.fieldName}<br>Error message: ${item.message}.`)})
        } else if (result?.field && result?.message) {
          respMsgArr.push({type:"danger", retryBtnText: 'Retry', retryBtnEvent: () => this.sendToMediaOcean(rfp), title:`${response?.status} - Unable to sent to Media Ocean`,"bodyMsgArr":[html`RFP name: ${rfp.rfp_name}<br>Field name: ${result.field}<br>Error message: ${result.message}.`]})
        }else {
          respMsgArr.push({type:"danger", retryBtnText: 'Retry', retryBtnEvent: () => this.sendToMediaOcean(rfp), title:`${response?.status} - Unable to sent to Media Ocean`,"bodyMsgArr":[html`RFP Name: ${rfp.rfp_name}.`]})
        }
        AlertMessagesService.showMultipleAlerts(respMsgArr);
        this.getRfpList()
      })
      .finally(() => {
        this.props.setSpinnerCount(0);
      })
  }

  /**
 * Opens the RFP preview modal and enables the print preview mode.
 *
 * @param {Object} rfp - The RFP object to be printed.
 * @returns {void}
 */
  printRfp = (rfp) => {
    this.openRfpPreviewModal(rfp)
    this.printPreview = true
  }

  /**
  * Removes a specific RFP (Request for Proposal) from the state's RFP data list.
  * @param {Object} rfp - The RFP object to be removed.
  * @returns {void}
  */
  removeRfpFromStateList = (rfp) => {
    const tempRfpData = [...this.state.rfpData]
    const rfpIndex = tempRfpData.findIndex((rfpObject) => rfpObject.id === rfp.id)
    tempRfpData.splice(rfpIndex, 1)
    this.setState({
      rfpData: tempRfpData
    })
    this.getRfpList();
  }

  /* The above code is defining a function called `closePreviewModal` using arrow function syntax in
  * JavaScript. This function updates the state of the component by setting the `rfpPreview` property
  * to `false`. It is likely used to close a modal or dialog box that displays a preview of a request
  * for proposal (RFP) in a React application. */
  closePreviewModal = () => {
    this.setState({ rfpPreview: false });
    this.printPreview = false
  }

  /**
 * Copies the RFP (Request for Proposal) by creating a duplicate RFP and updating the spinner count.
 *
 * @param {Object} rfp - The RFP object to be copied.
 * @returns {void}
 */
  copyRfp = (rfp) => {
    this.props.setSpinnerCount(1)
    const payload = RfpService.prepareDuplicateRfpPayload(
      rfp,
      this.props.omniProfile
    );
    
    let amdCampaignId = encodeURIComponent(rfp.amd_campaignid);
    RfpService.createRfp(payload, amdCampaignId)
    .then(() => {
      AlertMessagesService.showSuccessToastMessage('RFP Copied successfully');
      this.getRfpList('copy')
    })
    .catch(() => {
      AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.copyRfp(rfp), title: 'Unable to copy the RFP', bodyMsgArr: []}]);
    })
    .finally(() => {
      this.props.setSpinnerCount(0);
    });
  }

  /**
   * The above code is defining an array of objects, each representing a column in a
  table. Each object has properties such as label, key, default value, and a
  template function that generates the HTML for the cell in that column. The
  template function uses the provided value and index to generate the appropriate
  HTML for that cell. The code also includes some conditional logic for generating
  different actions based on the state of the table.
   * @returns {html element} return - html for cells
   */

  rfpTableColumns = () => [
    {
      label: 'NAME',
      key: 'rfp_name',
      default: '',
      isSortable: true,
      template: (value, index) => {
        return html`
        <style>
          :host::part(wrapText) {
            display: flex;
            flex-wrap: wrap;
            white-space: normal;
            line-height: 20px;
            max-height: 40px;
            overflow: hidden;
            word-break: break-all;
          }
        </style>
        <td part="table-body-cell name">
          <span part="td-content wrapText" style="width: ${Utils.calculatetaxonomyWidth(value)}">${value}</span>
        </td>`;
      }
    },

    {
      label: 'SELLER',
      key: 'provider_id',
      default: '',
      isSortable: true,
      template: (value, index) => {
        return html`<td part="table-body-cell">${value}</td>`;
      }
    },

    {
      label: 'Financial Supplier',
      key: 'financial_supplier',
      default: '',
      isSortable: true,
      template: (value, index) => {
        return html`<td part="table-body-cell">${value}</td>`;
      }
    },

    {
      label: 'EMAILS',
      key: 'recipients',
      default: '',
      isSortable: true,
      template: (value) => {
        return html`<td part="table-body-cell">${value}</td>`;
      }
    },

    {
      label: 'DUE DATE',
      key: 'response_due_date',
      default: '',
      isSortable: true,
      template: (value, index) => {return html`<td part="table-body-cell">${Utils.formatCalenderDate(value)}</td>`;}
    },

    {
      label: 'EXPORT STATUS',
      key: 'export_status',
      default: '',
      passthrough: true,
      isSortable: true,
      template: (value) => {
        return html`<td part="table-body-cell">${exportStatusHtml.getExportHTML(value, '')}</td>`;
      }
    },

    {
      label: 'ACTIONS',
      passthrough: true,
      key: 'actions',
      template: (value, index) => {
        if (this.state.activeTab) {
          return html`<td part="table-body-cell"><div part="row-action-icons">
        <div part="action-icon">
        <omni-sytyle>
            <omni-tooltip>
                <button slot="invoker" aria-haspopup="true" class="button is-text is-shadowless" ?disabled=${value.export_status==="RFP Sent"} @click=${(
                  e
                ) => {this.editRFPDailog(value)}}>
                    <omni-icon class="is-size-4 cursor" part="action-icon-inner" icon-id="omni:interactive:edit"></omni-icon>
                    </button>
                <div slot="content">Edit</div>
            </omni-tooltip>
            </omni-style>
    </div>
    <div part="action-icon">
        <omni-sytyle>
            <omni-tooltip>
                <button slot="invoker" aria-haspopup="true" class="button is-text is-shadowless" @click=${(
                  e
                ) => this.copyRfp(value)}>
                    <omni-icon class="is-size-4 cursor" part="action-icon-inner" icon-id="omni:interactive:copy"></omni-icon>
                    </button>
                <div slot="content">Copy</div>
            </omni-tooltip>
            </omni-style>
    </div>
    <div id="moreActions-${index}" part="action-icon" class="dropdown dropdownMoreActions  ${
            this.isDocumentMenuOpen ? 'is-active' : ''
          }">
                        <div class="dropdown-trigger">
                            <omni-sytyle>
                                <omni-tooltip>
                                    <button slot="invoker" aria-haspopup="true" class="button is-text is-shadowless" @click=${(
                                      e
                                    ) => {
                                      this.onDocumentTriggerClick(
                                        index,
                                        'moreActions',
                                        e
                                      );
                                    }}>
                                        <omni-icon class="is-size-4 cursor" part="action-button-icon" icon-id="omni:interactive:actions"></omni-icon>
                                    </button>
                                    <div slot="content">More Actions</div>
                                </omni-tooltip>
                                </omni-style>
                        </div>
                        <div part= "dropdown-menu" class="dropdown-menu" id="dropdown-menu" role="menu">
                            <div class="dropdown-content">
                                <a part="more-actions-item" class="dropdown-item" @click="${(
                                  e
                                ) => this.openRfpPreviewModal(value)}">Preview</a>
                                <a part="more-actions-item" class="dropdown-item" @click="${() => {this.sendToMediaOcean(value)}}">Send to Media Ocean</a>                        
                                <a part="more-actions-item" class="dropdown-item" @click="${() => {this.archiveOrActivateRfp(value)}}">Archive</a>
                                <a part="more-actions-item" class="dropdown-item" @click="${() => {}}">Share</a>
                                <a part="more-actions-item" class="dropdown-item" @click="${() => {this.printRfp(value)}}">Print</a>
                            </div>
                        </div>
    </div>
    </div></td>`;
        } else {
          return html`<td part="table-body-cell">
            <button class="button is-medium is-outlined" @click="${() => this.archiveOrActivateRfp(value)}">Restore</button>
          </td>`;
        }
      }
    }
  ];

  /**
   * This function closes all active dropdown menus except for the one with a specific prefix and
   * index.
   * @param {number} index - The index parameter is likely an integer value that is used to identify a
   * specific dropdown element. It is used in conjunction with the prefix parameter to create a
   * unique identifier for each dropdown element.
   * @param {string} prefix - The prefix parameter is a string that is used to identify a specific dropdown
   * element. It is concatenated with the index parameter to create a unique identifier for each
   * dropdown element.
   * @returns void
   */

  closeMenu(index, prefix) {
    let allDropdownEle = document
      .querySelector('omni-table')
      ?.shadowRoot.querySelector('omni-style')
      ?.querySelectorAll('.dropdown');
    allDropdownEle &&
      allDropdownEle.forEach((ele) => {
        if (ele.classList.contains('is-active') && ele.id !== prefix + index) {
          ele.classList.remove('is-active');
        }
      });
  }

  /** The below code is a JavaScript function that is triggered when a click event occurs on a document
   * element. It toggles the visibility of a dropdown menu and positions it based on the position of
   * the clicked element and the position of the table it is contained in. If the dropdown menu is
   * positioned near the bottom of the table, it is moved to the top. The function also prevents the
   * default behavior of the click event and stops it from propagating further.
   * @param {number} index - The index parameter is likely an integer value that is used to identify a
   * specific dropdown element. It is used in conjunction with the prefix parameter to create a
   * unique identifier for each dropdown element.
   * @param {string} prefix - The prefix parameter is a string that is used to identify a specific dropdown
   * element. It is concatenated with the index parameter to create a unique identifier for each
   * dropdown element.
   * @param {Event} event - click event of DOM element
   * @returns {void}
   */
  onDocumentTriggerClick = (index, prefix, event) => {
    // make the dropdown hide and show
    this.closeMenu(index, prefix);
    let el = document
      .querySelector('omni-table')
      ?.shadowRoot.querySelector('omni-style')
      ?.querySelector('#' + prefix + '-' + index);

    const eleRect = document
      .querySelector('#placement-table')
      .getBoundingClientRect();
    const targetRect = el.getBoundingClientRect();

    // Calculate the bottom positions
    const bottomPos = eleRect.bottom - targetRect.bottom;

    const elButton = el.querySelector('button');

    if (el) {
      el.classList.toggle('is-active');
      elButton.classList.toggle('is-active');
    }
    // move the dropdown to top for last 3 records
    if (bottomPos < 200 && !el.classList.contains('is-up)')) {
      el.classList.add('is-up');
    }

    // position the dropdown
    let dd = document
      .querySelector('omni-table')
      .shadowRoot.querySelector('omni-style')
      .querySelectorAll('.dropdown-menu');

    dd.forEach((ele) => {
      if (ele) {
        ele.style.left = prefix === 'documents' ? '-15px' : '-150px';
      }
    });

    event.stopPropagation();
    event.preventDefault();
  };

  /** The below code is defining a function called `pageInit` which initializes a page. It checks if the
  *`campaignObj` property exists in the `state` object of `props`. If it does, it sets the campaign
  *name and updates the state with the campaign object and loading status. If it doesn't exist, it
  *waits for 100 milliseconds and then retrieves campaign data using
  *`MediaOpsService.getCampaignData()` method with the `campaignId` parameter from `props`. It then
  *sets the campaign name, updates the state with the campaign object and loading status. Finally, it sets the spinner
  @return {void}
   */
  pageInit = () => {
    if (this.props?.state?.campaignObj?.id) {
      this.props.setCampaignName(Utils.formatCampaignTitle(this.props.state.campaignObj));
      this.setState({
        campaignObj: this.props.state.campaignObj,
        loading: false
      });
    } else {
      setTimeout(() => {
        let campaignId = decodeURIComponent(this.props.params.campaignId);;
        //todo rewrite below method
        MediaOpsService.getCampaignData(campaignId).then(
          (campaignData) => {
            campaignData['budget'] =
              campaignData['media_attributes']['media_budget'][
                'campaign_budget'
              ] || '';
            campaignData['channels'] =
              campaignData['media_attributes']['channels'] || '';
            this.props.setCampaignName(Utils.formatCampaignTitle(campaignData));
            this.setState({ campaignObj: campaignData, loading: false });
          }
        );
      }, 100);
    }
    this.props.setSpinnerCount(0);
  };

  /**
   * Fetches the RFP list based on the provided parameters.
   * Updates the component state with the fetched data and triggers necessary actions.
   * @param {Object} params - Optional parameters for the RFP list request.
   * @param {number} params.page-no - The page number for paginated results.
   * @returns {void}
   */

  getRfpList = (type = 'fetch', params = {}, filter = false) => {
      // Check if "page-no" is not included in the parameters, indicating the start of a new data fetch.
    let filterParams = this.state.filterData;
    if(filter){
      filterParams = {};
      this.setState({ filterData: params });
    }

    if (!Object.keys(params).includes("page-no")) {
      this.tablePageNo = 1;
      this.setState({ loading: true});
      
      if(!filter){
        this.setState({ filterData: {} });
        filterParams = {};
      }
    }
      // Set filtersApplied based on whether any parameters are present.
    this.setState({ filtersApplied: !!Object.keys(params).length });
      // Add 'is-delete' parameter to queryParams based on the activeTab state.
    let queryParams = {...params, ...filterParams, 'is-delete': !this.state.activeTab}
    let campaignId = encodeURIComponent(this.props.state.campaignObj.id);
    RfpService.getRfpList(campaignId, queryParams)
      .then((res) => {
            // Update the RFP data in the state based on the page number.
        let rfpData = res.Items;
        if(res.Items.length){
          if (params["page-no"] > 1) {
            rfpData = this.state.rfpData;
            res.Items.map(rfp => !rfpData.includes(rfp) && rfpData.push(rfp));
          }else{
            this.totalCount = res.total_records;
            this.apiCallCount = Math.ceil(this.totalCount*0.1);
          }
          this.fetchCount = rfpData.length;
          this.setState({ rfpData: rfpData });
        }
        // If the filter is applied and no data is found, update the state with the fetched data.
        else if(!res?.Items?.length){
          this.totalCount = res.total_records;
          this.fetchCount = res.Items.length;
          this.setState({ rfpData: res.Items });
        }
        // Update component state with the fetched data, total count, and fetch count.
            // Check if there are any items in the fetched data and update the table value check.
        this.props.setCheckTableValue(!!this.totalCount)
      })
      .catch((error) => {
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.getRfpList(type, params, filter), title: `Unable to ${type} the RFP`, bodyMsgArr: []}]);
      })
            // Reset the spinner count and loading state after the fetch operation is completed.
      .finally(() => {
        this.props.setSpinnerCount(0);
        this.setState({ loading: false, scrollFlag: true});
      });
  };

  componentDidMount() {
    this.pageInit();
    if (this.props.state.campaignObj.id) {
      this.getRfpList();
    }
    this.props.setCheckTableValue(!!this.totalCount)
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.resizeTableHeight);
  }
  componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.resizeTableHeight);
  }
  /**
   * Handles the scroll event for the RFP details table.
   * It checks if the user has scrolled to the bottom of the table and triggers
   * additional data fetching if there is more data to load.
   * @returns {void}
   */
  handleScroll = () => {
      // Extract scroll-related properties from the table
      const { scrollHeight, scrollTop, clientHeight } = document.documentElement;
      // Calculate the scroll condition based on the current scroll position
      const scrollCondition = (clientHeight + Math.round(scrollTop) === scrollHeight)
      ? clientHeight + Math.round(scrollTop)
      : (clientHeight + Math.round(scrollTop) < scrollHeight)
      ? clientHeight + Math.round(scrollTop) + 1
      : (clientHeight + Math.round(scrollTop) > scrollHeight)
      && clientHeight + Math.round(scrollTop) - 1;
      
      if(this.tablePageNo < this.apiCallCount){
        // If the scroll condition is met, fetch more data
        if (this.fetchCount < this.totalCount && this.state.scrollFlag) {
          if (scrollCondition === scrollHeight) {
            this.setState({scrollFlag: false});
            this.tablePageNo = this.tablePageNo + 1;
            this.getRfpList('fetch', {"page-no": this.tablePageNo});
            this.props.setSpinnerCount(1);
          }
        }
      }
    }

  /**
   * Adjusts the height of the RFP table based on the window height.
   * Triggers additional data fetching if there is more data to load.
   * @returns {void}
   */
  resizeTableHeight = () => {
    if(this.tablePageNo < this.apiCallCount){
      // Check if there is more data to fetch
      if(this.fetchCount < this.totalCount && this.state.scrollFlag){
        // Check window height and fetch more data accordingly
        if (window.innerHeight > 950 && this.fetchCount === 10) {
          this.setState({scrollFlag: false});
          this.props.setSpinnerCount(1);
          this.tablePageNo = this.tablePageNo + 1;
          this.getRfpList('fetch', {"page-no": this.tablePageNo});
        } else if (window.innerHeight > 1500 && this.fetchCount <= 40) {
          this.setState({scrollFlag: false});
          this.props.setSpinnerCount(1);
          this.tablePageNo = this.tablePageNo + 1;
          this.getRfpList('fetch', {"page-no": this.tablePageNo});
        }
      }
    }
  }

  /**
   * The function generates a skeleton table with 6 identical rows without a header row.
   * @returns a JSX element that contains 10 div elements with the class name "table skeleton", which
   * are meant to represent a work-in-progress (WIP) table with a skeleton layout. The rows are
   * concatenated into a string using a for loop and then parsed into HTML using the `parse()` function.
   */
  displaySkeletonTable() {
    // Per Omni-UI, the skeleton WIP table should be 6 identical rows, without the header row.
    let rows = '';
    for (let i = 0; i < 10; i++) {
      rows = rows + '<div className="table skeleton"></div>';
    }
    rows = html`${rows}`;
    return <>{parse(rows.values[0])}</>;
  }

  /**
   * Sets the active tab and retrieves the RFP list if the active tab is not already set.
   * @returns {void}
   */
  setActiveTab = () => {
    if (!this.state.activeTab) {
      this.setState({ activeTab: true }, this.getRfpList)
    }
  }

  /**
   * Sets the archive tab and triggers the retrieval of RFP list if the active tab is currently set.
   * @returns {void}
   */
  setArchiveTab = () => {
    if (this.state.activeTab) {
      this.setState({ activeTab: false }, this.getRfpList)
    }
  }

  /**
   * Description The above code is defining a function called `editRFPDailog` that takes in a parameter `rfp`.
   * Within the function, it sets the state of `editRFPData` to the value of `rfp` and then calls a
   * function `setIsRfpModalOpen` with a value of `true` as a parameter, which is a prop passed down
   * to the component. This function is likely used to open a modal or dialog box for editing a
   * Request for Proposal (RFP) in a React application.
   * @param {object} rfp
   */
   editRFPDailog = (rfp) =>{
    this.setState({editRFPData: rfp});
    this.props.setIsRfpModalOpen(true);
  }

  render() {
    return (<>
      <div className='rfp-details-container'>
        <OmniStyleComponent>
          <OmniTileComponent heading=''>
            <OmniToolbarComponent slot='header'>
              <div slot='start' className='headerStartButtons'>
                <button className={`is-primary ${this.state.activeTab ? 'is-active' : ''}`} onClick={this.setActiveTab}>Active RFPs</button>
                <button className={`is-primary ${!this.state.activeTab ? 'is-active' : ''}`}onClick={this.setArchiveTab}>Archive RFPs</button>
              </div>
              <div slot='end' className='custom-dropdown-menu'>
                <OmniSearchComponent
                  className='search-input-icon'
                  onSearchUpdate={(event) => {this.getRfpList('search', {search: event.target.value}, true)}}
                  slot='end'
                  ph='Search'
                ></OmniSearchComponent>
                <div className='filter-menu'>
                  <div className='separater-vertical'></div>
                  <RfpFilterComponent onApplyFilter={this.getRfpList.bind(this, 'filter')} />
                </div>
              </div>
            </OmniToolbarComponent>
          </OmniTileComponent>
        </OmniStyleComponent>
        {this.state.loading ? (
          this.displaySkeletonTable()
        ) : this.state.rfpData?.length ? (
          <OmniTableComponent
            class='card'
            footer={true}
            id='placement-table'
            data={this.state.rfpData}
            columns={this.rfpTableColumns()}
            sort={this.state.sort}
            onSortUpdate={this.onSortUpdate}
            key={this.state.rfpData.length}
          ></OmniTableComponent>
        ) : (
          <div className='no-placements-content'>
            <div>
              <img src={handIcon} alt='Icon' className='icon-subscription' />
            </div>
            <div>
                  <p>{this.state.filtersApplied ?'No Data Found!': 'You have no RFPs for this campaign.' }</p>
            </div>
            <div>
                  {!this.state.filtersApplied && <button
                    className='button is-medium is-outlined'
                    onClick={() => {
                      this.props.setIsRfpModalOpen(true);
                    }}
                  >
                    Create RFP
                  </button>}
            </div>
          </div>
        )}
        <RfpDialogComponent
          isRfpModalOpen={this.props.isRfpModalOpen}
          onDialogClose={() => {
            this.setState({editRFPData:null});
            this.props.setIsRfpModalOpen(false);
          }}
          onRfpCreate={this.getRfpList}
          campaignObj={this.state.campaignObj}
          omniProfile={this.props.omniProfile}
          editRFPData={this.state.editRFPData}
        />
        <RfpPreview
          isRfpPreviewOpen={this.state.rfpPreview}
          rfp={this.selectedRfp}
          campaignObj={this.state.campaignObj}
          closePreviewModal={this.closePreviewModal}
          printPreview={this.printPreview}
          {...this.props}
        />
      </div>
      {(!this.state.loading && this.state.rfpData.length > 0) && ( 
        <div className="show-more-button">
          <div>
            Showing 1-{this.fetchCount} of {this.totalCount}
          </div>        
        </div>
      )}
    </>
    );
  }
}
